
import { Component, Vue, Watch } from 'vue-property-decorator';
import { JoinVO } from '@/views/biz/login/vo/JoinVO.vo'
import { LoginVO } from '@/views/biz/login/vo/LoginVO.vo'
import { MemberVO } from '@/views/biz/login/vo/MemberVO.vo'
import { CommonCodeIVO, CommonCodeOVO } from '@/views/bizcommon/code/vo/CodeVO.vo'
import SettingsDialog from '@/components/SettingsDialog.vue'
import VuetifyConfirm from 'vuetify-confirm'
import CommonUtils from '@/common-utils'
import Constants from '@/constants'

import axios from 'axios';

@Component({
  components: { SettingsDialog }
})
export default class LayoutMain extends Vue {
  isLogin = false;
  member: MemberVO = {} as MemberVO;
  // 매뉴
  drawer = false;

  // 매뉴 아이콘 선택
  onDrawer() {
    axios.get('/member')
    .then(r => {
      if(r.data) {
        this.member = r.data;
      } else {
        this.member = {} as MemberVO;
      }
      this.drawer = !this.drawer;
    })
  }

  // 매뉴 선택
  selectMenus(routeName): void {
    this.$router.push({name: routeName});
    this.drawer = false;
  }

  async doLogout() {
    const opt = CommonUtils.baseConfirmOption;
    // opt.title = ' ';
    const res = await this.$confirm('로그아웃 하실건가요?', opt);

    if(res) {
      axios.get("/logout")
      .then(()=>{
        if(this.$route.name == 'Main') {
          this.$router.go(0);
        } else {
          this.$router.push({name: 'Main'});
        }
      }); 
    }
  }

  moveMypage(): void {
    if(this.member) {
      this.$router.push({name: 'Mypage'})
    } else {
      this.$router.push({name: 'Login'})
    }
  }

  created(): void {
    this.$route.name || this.$router.push({name: 'Main'})
  }
}
